import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import EmptyTenantIcon from '../../../components/icons/EmptyTenantIcon';
import OnboardUserButton from '../../../components/molecules/buttons/OnboardUserButton';

/**
 * EmptyTenant component
 *
 * @return {*}
 */
const EmptyTenant: React.FC = () => {
  return (
    <View style={styles.emptyContainer}>
      <EmptyTenantIcon />
      <Text style={styles.emptyText}>No Wallet Users Found</Text>
      <Text style={styles.emptySubText}>
        You don't have any active wallet users or pending invitations at the moment.
      </Text>
      <Text style={styles.emptySubText}>
        Get started by inviting users to connect their wallets.
      </Text>
      <OnboardUserButton title="+ Invite User" />
    </View>
  );
};

const styles = StyleSheet.create({
  emptyText: {
    fontSize: 24,
    fontWeight: '700',
    color: '#495057',
    textAlign: 'center'
  },
  emptySubText: {
    fontSize: 16,
    fontWeight: '400',
    color: '#6c757d',
    textAlign: 'center',
    lineHeight: 22
  },
  emptyContainer: {
    margin: 0,
    height: '90%',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 15,
    paddingHorizontal: 20
  }
});

export default EmptyTenant;
